import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "../../utils/storeApp";
import { loadUserValues } from "../../services/loadUserValues";

const CHANNEL_NAME = "backend-toggle";

const BackendToggle = () => {
  const { backendTarget, setBackendTarget, userToken, SetSharedObject } =
    useUserStore((state) => ({
      backendTarget: state.backendTarget,
      setBackendTarget: state.setBackendTarget,
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
    }));

  const navigate = useNavigate();
  const channelRef = useRef(null);

  useEffect(() => {
    channelRef.current = new BroadcastChannel(CHANNEL_NAME);
    channelRef.current.onmessage = (e) => {
      if (e.data?.backendTarget) {
        setBackendTarget(e.data.backendTarget);
        // Reload reference data for the newly-selected backend in this (other) tab too.
        // Read token/setter fresh from the store since this closure is long-lived.
        loadUserValues(
          useUserStore.getState().userToken,
          useUserStore.getState().SetSharedObject
        );
        navigate("/dashboard");
      }
    };
    return () => channelRef.current?.close();
  }, [setBackendTarget, navigate]);

  const handleChange = (target) => {
    if (target === backendTarget) return;
    setBackendTarget(target); // zustand set is synchronous → getState().backendTarget is now `target`
    channelRef.current?.postMessage({ backendTarget: target });
    // Reload customers/orgs/reference data for the new backend HERE rather than via a
    // [backendTarget] effect: the navigate() below remounts this component (resetting the
    // effect's first-run guard), so the effect-based reload was being skipped — leaving the
    // dropdowns on the previous backend's data. apiCalls reads backendTarget from the store
    // at call time, so this fires GetUsersValues against the newly-selected backend.
    loadUserValues(userToken, SetSharedObject);
    navigate("/dashboard");
  };

  return (
    <li className="nav-item d-flex align-items-center sp-margin5">
      <span className="text-light me-2" style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>
        Backend:
      </span>
      <div className="d-flex gap-2">
        <label className="text-light" style={{ fontSize: "0.8rem", cursor: "pointer" }}>
          <input
            type="radio"
            name="backendTarget"
            value="aws"
            checked={backendTarget === "aws"}
            onChange={() => handleChange("aws")}
            className="me-1"
          />
          AWS
        </label>
        <label
          className={backendTarget === "gcp" ? "text-warning fw-bold" : "text-light"}
          style={{ fontSize: "0.8rem", cursor: "pointer" }}
        >
          <input
            type="radio"
            name="backendTarget"
            value="gcp"
            checked={backendTarget === "gcp"}
            onChange={() => handleChange("gcp")}
            className="me-1"
          />
          GCP
        </label>
      </div>
    </li>
  );
};

export default BackendToggle;
